import {Component, Input, OnInit} from '@angular/core'
import {FloatObjectService} from './float-object.service'

@Component({
  selector: 'dmmp-float-object',
  templateUrl: './float-object.component.html',
  styleUrls: ['./float-object.component.scss']
})
export class FloatObjectComponent implements OnInit {

  @Input() identifier
  @Input() data
  positionElement: object

  constructor(private floatService: FloatObjectService) {
  }

  ngOnInit() {
    if (this.data.content.position) {
      this.positionElement = this.floatService.selectPosition(this.data?.content?.position)
    }
  }
}
